import type { QueryKey } from '@tanstack/react-query';

import { window } from '../../../globals';
import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';

export const getUserMasqueradeQueryKey: QueryKey = ['users', 'masquerade', 'get', 'mask'];

async function getUserMasqueradeQuery() {
  return get<{ userId: number | null; username: string | null }>('/api/users/masquerade/masquerading');
}

/**
 * Gets information about what user the super admin is masquerading as.
 *
 * The cache timeout for masquerading is 30 minutes, so this will fetch every
 * minute to check if the super admin is still masquerading as someone.
 */
export default function useGetUserMasquerade() {
  return useQuery<{ userId: number | null; username: string | null }>({
    queryKey: getUserMasqueradeQueryKey,
    queryFn: getUserMasqueradeQuery,
    enabled: !!window.user?.super,
    staleTime: 1 * 60 * 1000,
  });
}
